import { baseRoute, asyncRoutes } from '@/router';
import { authorityList,htRoleGetRole } from '@/api/limit.js';
const state = {
  routes: [],
  menuList: []
};

const mutations = {
  SET_ROUTE(state, route) {
    state.routes = route;
  },
  RESET_ROUTE(state) {
    state.routes = [];
  }
};

const actions = {
  async getRoute({ commit }, role) {
      let res =  await authorityList()
      let accessedRoutes = asyncRoutes;
      let identifierRes = await htRoleGetRole();
      accessedRoutes = getMenuListTree(asyncRoutes, res.data,identifierRes.data.identifier);
      accessedRoutes.push(...baseRoute);
      commit('SET_ROUTE', accessedRoutes);
       if(accessedRoutes[0] && accessedRoutes[0].children[0] &&accessedRoutes[0].children[0].children){
        let root = accessedRoutes[0];
        let childrenRoutes = root.children[0];
        let childRoute = childrenRoutes.children[0];
        childrenRoutes.redirect = childRoute.path
      }
      return accessedRoutes;
  
  }
  //   //仅测试用，生产请去掉
  //   async changeRole({ commit, dispatch }, role) {
  //     await dispatch('user/login', role);
  //     resetRouter();
  //     const accessedRoutes = await dispatch('getRoute', role);
  //     router.addRoutes(accessedRoutes);
  //     await dispatch('tagsView/clearTag', null, { root: true });
  //   }
};

export function getMenuListTree(routes, menuList,identifier) {
  let menuStrList = menuList.map(item => item.authorityCode);
  menuTree(menuStrList, routes,identifier);
  return routes;
}

function menuTree(list, routes,identifier) {
  if (routes) {
    for (let i = routes.length - 1; i >= 0; i--) {
      if ( (routes[i].meta && routes[i].meta.identifier && identifier !== 0) || (routes[i].meta && !routes[i].meta.base && !routes[i].meta.identifier && !list.includes(routes[i].meta.role))) {
        routes.splice(i, 1);
      } else {
        menuTree(list, routes[i].children,identifier);
      }
    }
  } else {
    return;
  }
}

export function filterAsyncRoute(routes, role) {
  let arr = [];
  routes.forEach(item => {
    const temp = { ...item };
    if (hasChildren(temp, role)) {
      if (temp.children) {
        temp.children = filterAsyncRoute(temp.children, role);
      }
      arr.push(temp);
    }
  });
  return arr;
}

export function hasChildren(route, role) {
  let roleIds = role.split(',');
  if (route.meta && route.meta.role) {
    return roleIds.includes(String(route.meta.role));
  } else {
    return true;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
